import { httpRequest } from "@services/http"
import type { EngagementBudgetHeader } from "@models/engagementBudgetTree.model"

const num = (v: unknown): number => (typeof v === "number" ? v : parseFloat(String(v ?? 0)) || 0)
const intOrNull = (v: unknown): number | null =>
  v == null ? null : (typeof v === "number" ? v : parseInt(String(v), 10) || 0)

export class CommandGetEngagementBudget {
  async run(engagementId: number): Promise<EngagementBudgetHeader> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/budget/`
    const r = await httpRequest<any>(url, { method: "GET" })
    return {
      balance: num(r.balance),
      remaining_flight_funding: num(r.remaining_flight_funding),
      funding_end: r.funding_end ?? null,
      active_days_remaining: num(r.active_days_remaining),
      next_replenish_date: r.next_replenish_date ?? null,
      days_until_replenish: intOrNull(r.days_until_replenish),
      spend_window_days: num(r.spend_window_days),
      daily_spend_target: num(r.daily_spend_target),
      total_debits: num(r.total_debits),
      // Defaults to blank for a server predating MPN-1792, so the stat reads "—" rather
      // than "undefined".
      billing_method: r.billing_method != null ? String(r.billing_method) : "",
      is_projected: Boolean(r.is_projected),
    }
  }
}
